import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import GenericGuideRemarkBlockData from '../../../Models/Content/GenericGuideRemarkBlockData';
import GenericGuideRemark from './GenericGuideRemarkBlock';

export default class GenericGuideRemarkBlock extends EpiComponent<GenericGuideRemarkBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['generic-guide-remark-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <GenericGuideRemark iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

